<template>
  <div>
    <dd-modal :visible="listVisible" @cancel="listVisible = false" :show-cancel="true" width="600px">
      <AutomationResultOverviewComponent
        @done="$emit('done')"
        @hide-list="listVisible = false"
        :automation="automation"
      />
    </dd-modal>

    <dd-header-card
        :nested="true"
        class="automation-card"
        @click="(evt) => evt.target.classList.contains('header') && editList()"
        :header="automation.title">
      <div class="flex-col justify-content-between gap-md">
        <div class="automation-card-content">
          {{ automation.description }}
        </div>
        <div class="flex-row gap-md align-items-center justify-content-between">
          <div class="flex-row">
            <a-tooltip placement="top">
              <template #title>Verzendlijst aanpassen</template>
              <dd-rounded-button @click="editList" :small="true" :outline="true">
                <template #icon>
                  <PencilIcon class="fill-primary icon-size-sm"/>
                </template>
              </dd-rounded-button>
            </a-tooltip>

            <AutomationSelectionSummary :automation="automation"/>
          </div>
        </div>
      </div>
    </dd-header-card>
  </div>
</template>

<script>
import AutomationSelectionSummary from "../AutomationSelectionSummary.vue";
import AutomationResultOverviewComponent from "./AutomationResultOverviewComponent.vue";

export default {
  name: "AutomationConfirmationCard",
  components: {
    AutomationResultOverviewComponent,
    AutomationSelectionSummary
  },
  props: {
    automation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      listVisible: false,
    };
  },
  methods: {
    editList() {
      this.listVisible = true;
      this.$emit('editList', this.automation);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.automation-card {
  .automation-card-content {
    background-color: white;
    padding: $spacing-md;
  }
}
</style>
